import { _footerFr as footer } from './footer/footer';
import { _cookiesFr as cookie } from './cookies/cookies';
import { _notificationsFr as notifications } from './notifications/notifications';
import { _alertsFr as alerts } from './alerts/alerts';
import { _sessionFr as session } from './session/session';
import { _rightMenuFr as rightMenu } from './menus/rightMenu';
import { _gamesTableFr as gamesTable } from './tables/gamesTable';
import { _modalsFr as modals } from './modals/modals';
import { _homePageFr as gameHomePage } from './gameHomePage/home';
import { _configFr as config } from './configuration/config';
import { _defaultFr as defaults } from './default';
import { _authFr as auth } from './configuration/authorizations';
import { _assignmentsFr as assignments } from './assignments/assignments';
import { _planningFr as planning } from './assignments/planning';
import { _sgaFr as sga } from './sga/sga';
import { _sgoFr as sgo } from './sgo/sgo';
import { _sigFr as sig } from './sig/sig';
import { _bipFr as bip } from './bip/bip';
import { _radioFr as radio } from './radio/radio';
import { _ticketFr as ticket } from './assignments/ticket';
import { _shopFr as shop } from './shop/shop';

export const fr = {
    title: 'Alertes Spéciales',
    module: 'module role play',
    chooseLangage: 'Choisir la langue',
    account: 'compte',
    disconnect: 'Déconnexion',
    refresh: 'Raffraichir',
    loading: 'Chargement',
    load: 'Charger',
    to: 'À',
    send: 'Envoyer',
    allRights: 'Tous droits réservés',
    create: 'Créer',
    game: 'Partie',
    changeThemeDark: 'Utiliser le mode sombre',
    changeThemeLight: 'Utiliser le mode clair',
    yes: 'Oui',
    no: 'Non',
    delete: 'Supprimer',
    cancel: 'Annuler',
    validate: 'Valider',
    close: 'Fermer',

    defaults,
    footer,
    cookie,
    notifications,
    alerts,
    session,
    rightMenu,
    gamesTable,
    modals,
    gameHomePage,
    config,
    auth,
    assignments,
    planning,
    sga,
    sgo,
    sig,
    bip,
    radio,
    ticket,
    shop,
};
